var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_4044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9989 8.99823V2.99933C6.9989 2.73416 6.89356 2.47985 6.70606 2.29235C6.51856 2.10485 6.26425 1.99951 5.99908 1.99951H1.99982C1.73465 1.99951 1.48034 2.10485 1.29284 2.29235C1.10534 2.47985 1 2.73416 1 2.99933V8.49832C1 8.6309 1.05267 8.75806 1.14642 8.85181C1.24017 8.94556 1.36732 8.99823 1.49991 8.99823H2.49972",
    stroke: "#FE9A00",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49847 8.99829H4.49902",
    stroke: "#FE9A00",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49808 8.99835H10.4979C10.6305 8.99835 10.7576 8.94568 10.8514 8.85193C10.9451 8.75818 10.9978 8.63103 10.9978 8.49844V6.67378C10.9976 6.56033 10.9588 6.45032 10.8878 6.36183L9.14814 4.18723C9.10139 4.12868 9.04207 4.08139 8.97458 4.04886C8.90708 4.01632 8.83314 3.99937 8.75821 3.99927H6.99854",
    stroke: "#FE9A00",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49835 9.99817C9.05054 9.99817 9.49817 9.55054 9.49817 8.99835C9.49817 8.44617 9.05054 7.99854 8.49835 7.99854C7.94617 7.99854 7.49854 8.44617 7.49854 8.99835C7.49854 9.55054 7.94617 9.99817 8.49835 9.99817Z",
    stroke: "#FE9A00",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49933 9.99817C4.05151 9.99817 4.49915 9.55054 4.49915 8.99835C4.49915 8.44617 4.05151 7.99854 3.49933 7.99854C2.94714 7.99854 2.49951 8.44617 2.49951 8.99835C2.49951 9.55054 2.94714 9.99817 3.49933 9.99817Z",
    stroke: "#FE9A00",
    strokeWidth: 0.999817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_4044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9978,
    height: 11.9978,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeTruck);
export default __webpack_public_path__ + "static/media/orange_truck.bcc3d7e5b34a631efb8b2326a4b3585c.svg";
export { ForwardRef as ReactComponent };